module.exports = __webpack_public_path__ + "static/media/Eth.8494c5b5.png";